import DashboardMixin from '@/mixins/dashboard';

export default {
  mixins: [DashboardMixin],

  computed: {
    // Default implementation - components can override this if needed
    activeItem() {
      return null;
    },
    navigationItems() {
      const ni = this.$store.getters['navigationItems/menuItems'];
      return ni.filter(ni => !ni.dynamic && this.canAccessDashboardResource(ni));
    },
  },

  methods: {
    navItemActive(navItem) {
      if (this.activeItem?.id) {
        return this.activeItem.id === navItem.id;
      }
      return this.active?.id === navItem.id;
    },
    navItemClicked(navItem, closeFunction = null) {
      const navGroup = this.$store.getters['navigationGroups/navigationGroups'][navItem.navigationGroupId];
      this.$analytics.events.selectedNavItem(navItem, navGroup, null);
      if (closeFunction) {
        closeFunction();
      }
    },
    navItemIcon(navItem) {
      return this.navItemActive(navItem) ? navItem.activeIcon : navItem.icon;
    },
  },
};
